import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface TabsState {
  activeTab: string | null;
  tabs: string[];
  isEnabled: boolean;
}

const initialState: TabsState = {
  activeTab: null,
  tabs: [],
  isEnabled: false,
};

export const tabs = createSlice({
  name: 'tabs',
  initialState,
  reducers: {
    setTabs: (state, action: PayloadAction<string[]>) => {
      state.tabs = action.payload;
      state.isEnabled = action.payload.length > 0;
    },

    setActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload;
    },

    disableTabs: (state) => {
      state.tabs = [];
      state.activeTab = null;
      state.isEnabled = false;
    },
  },
});

export const { setTabs, setActiveTab, disableTabs } = tabs.actions;

// selectors
export const activeTabSelector = (state: { tabs: TabsState }) => state.tabs.activeTab;

export const tabsSelector = (state: { tabs: TabsState }) => state.tabs.tabs;

export const tabsEnabledSelector = (state: { tabs: TabsState }) => state.tabs.isEnabled;

export default tabs.reducer;
